import styled from "styled-components";

export const HomeWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #fff;
    padding-top: 88px;
`;
